import React from "react";

const ShowBooleanAsIcon = ({ isTruthy }) => (isTruthy
  ? <i className="bi-check-circle-fill text-success" />
  : <i className="bi-x-circle-fill text-danger" />);

export default ShowBooleanAsIcon;
